/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sample_Bound_OnlyInputs */

const cs_builder_sample_bound_only = /** @type {(inputs: Builder_Sample_Bound_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen vázaná pole`)
};

const en_builder_sample_bound_only = /** @type {(inputs: Builder_Sample_Bound_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bound fields only`)
};

/**
* | output |
* | --- |
* | "Bound fields only" |
*
* @param {Builder_Sample_Bound_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sample_bound_only = /** @type {((inputs?: Builder_Sample_Bound_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sample_Bound_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sample_bound_only(inputs)
	return cs_builder_sample_bound_only(inputs)
});